class CustomDropdown extends HTMLElement {
  constructor() {
    super();
    this.dropdownContainer = null;
    this.dropdownButton = null;
    this.dropdownList = null;
    this.cards = null;
  }

  connectedCallback() {
    this.initializeElements();
    this.setupDropdown();
  }

  initializeElements() {
    this.dropdownContainer = this.querySelector('.custom-select');
    this.dropdownButton = this.querySelector('#dropdownButton');
    this.dropdownList = this.querySelector('#dropdownList');
    this.cards = document.querySelectorAll('.filter-value');
  }

  setupDropdown() {
    const states = [...new Set([...this.cards]
      .map(card => card.getAttribute('data-filter')?.trim())
      .filter(state => state))];

    if (states.length === 0) {
      if (this.dropdownContainer) {
        this.dropdownContainer.classList.add('hidden');
      }
      return;
    }

    states.sort((a, b) => {
      try {
        const yearA = parseInt(a.split('-')[0]) || 0;
        const yearB = parseInt(b.split('-')[0]) || 0;
        if (yearA !== yearB) {
          return yearA - yearB;
        }
        return a.includes('-') - b.includes('-');
      } catch (error) {
        console.error('Error sorting states:', error);
        return 0;
      }
    });

    states.unshift('All');
    states.forEach(state => {
      const li = document.createElement('li');
      li.textContent = state;
      li.dataset.value = state;
      this.dropdownList.appendChild(li);
    });

    this.dropdownButton?.addEventListener('click', () => {
      this.dropdownList?.classList.toggle('hidden');
    });

    this.dropdownList?.addEventListener('click', (event) => {
      if (event.target.tagName === 'LI') {
        const selectedState = event.target.dataset.value;
        this.dropdownButton.textContent = selectedState;
        this.dropdownList.classList.add('hidden');

        this.cards.forEach(card => {
          if (selectedState === 'All' || card.getAttribute('data-filter') === selectedState) {
            card.classList.remove('hidden');
          } else {
            card.classList.add('hidden');
          }
        });
      }
    });

    document.addEventListener('click', (event) => {
      if (!this.dropdownButton?.contains(event.target) && !this.dropdownList?.contains(event.target)) {
        this.dropdownList?.classList.add('hidden');
      }
    });
  }
}

customElements.define('custom-dropdown', CustomDropdown);
